<svg width="30" height="35" viewBox="0 0 30 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.5 6.31436V17.3394C1.5 28.3644 15 33.0894 15 33.0894C15 33.0894 28.5 28.3644 28.5 17.3394V6.31436L15 1.58936L1.5 6.31436Z" stroke="#E5E5E5" stroke-width="3" stroke-linecap="square"/>
<path d="M9.25977 16.0985L13.5003 20.3405L21.9858 11.855" stroke="#E5E5E5" stroke-width="3" stroke-linecap="square"/>
</svg>
